import { Component } from 'react';
import { Select } from 'antd';
import { getLang } from '@src/packages/pro-table/component/util';
class Enum extends Component<{
  schema?: {
    [x: string]: any;
    items?: Array<any>;
  };
  disabled?: boolean;
  value?: any;
  onChange?: (val: any) => void;
}> {
  render() {
    const locale = getLang();
    const currentLocale = locale.split('-')[0];
    const isNumber = this.props.schema?.type === 'number';
    const convertValue = isNumber
      ? parseInt(this.props.value)
      : this.props.value;
    return (
      <Select
        disabled={this.props.disabled}
        value={convertValue || ''}
        onChange={(val) => {
          if (val === '') val = null;
          if (this.props.onChange) {
            this.props.onChange(val);
          }
        }}
      >
        <Select.Option value=''>
          {currentLocale === 'la'
            ? 'ຢ່າເລືອກ'
            : currentLocale === 'en'
            ? 'Do not select'
            : 'Không chọn'}
        </Select.Option>
        {(this.props.schema?.items ?? []).map((item, index) => {
          let itemValue = isNumber ? parseInt(item.value) : item.value;
          let itemKey = item.key;
          if (
            item.key.includes('&') &&
            item.key.includes(`${currentLocale}=`)
          ) {
            item.key.split(`&`).forEach((lang: string) => {
              if (lang.includes(`${currentLocale}=`)) {
                itemKey = lang.split(`=`)[1];
              }
            });
          }
          return (
            <Select.Option value={itemValue} key={index}>
              {itemKey}
            </Select.Option>
          );
        })}
      </Select>
    );
  }
}

export default Enum;
